import { Box, Typography, Button, Chip, useTheme } from '@mui/material';

interface PreviewOverlayProps {
  title: string;
  description: string;
  actionText?: string;
  onAction?: () => void;
}

export function PreviewOverlay({ title, description, actionText, onAction }: PreviewOverlayProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(135deg, ${theme.palette.primary.main}F0 0%, ${theme.palette.primary.dark}F0 100%)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
        p: 3,
        zIndex: 10,
        borderRadius: 1,
      }}
    >
      <Chip
        label="Vista Previa"
        size="small"
        sx={{
          mb: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          color: 'white',
          fontWeight: 600,
          fontSize: '0.75rem',
        }}
      />
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, maxWidth: 280, lineHeight: 1.5, opacity: 0.9 }}>
        {description}
      </Typography>
      {actionText && onAction && (
        <Button
          variant="contained"
          size="small"
          onClick={onAction}
          sx={{
            backgroundColor: 'white',
            color: 'primary.main',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
            },
          }}
        >
          {actionText}
        </Button>
      )}
    </Box>
  );
}
